import React from "react";

import { Link } from "src/components/ui/link";

const ConsentText = () => {
  return (
    <p className="text-xs text-center text-muted-foreground">
      By continuing, you are agreeing to our{" "}
      <Link
        href="https://lumonic.com/privacy-policy"
        target="_blank"
        rel="noopener noreferrer"
      >
        privacy policy
      </Link>{" "}
      and{" "}
      <Link
        href="https://lumonic.com/terms-of-use"
        target="_blank"
        rel="noopener noreferrer"
      >
        terms of service
      </Link>
      .
    </p>
  );
};

export default ConsentText;
